import { NgModule } from '@angular/core';

import { TipComponent } from './tip.component';
import { TipDirective } from './tip.directive';

const exportedDeclarations = [TipDirective, TipComponent];

@NgModule({
  imports: [],
  declarations: exportedDeclarations,
  exports: exportedDeclarations,
})
export class TipModule {}
